<div class="flex items-center justify-end">
  <button
    type="button"
    class="btn-filter"
    data-cy="FilterBuilder:TriggerBtn"
    [class.active]="filterBuilder?.showFilters || comparisonFiltersCount > 0"
    blazeClickable
    (click)="toggleFilters()"
  >
    Filter
    <span class="icon">
      <mat-icon svgIcon="icon_filter_16" />
      @if (comparisonFiltersCount > 0 && !filterBuilder?.showFilters) {
        <span class="filters-count" data-cy="FilterBuilder:FiltersCount">{{
          comparisonFiltersCount
        }}</span>
      }
    </span>
  </button>
</div>
